import { FC, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';

import styled from 'styled-components';

import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { CircularProgress } from '@mui/material';

import { router } from './routes/browserRouter';
import { createMsalInstance } from './services/azure';
import './styles/main.scss';
import { Theme } from './theme';
import { ReduxWrapper } from './wrappers';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
`;

const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  width: 60vw;
  height: 60vh;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 20px 20px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
`;

const Column = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledImage = styled.img`
  height: 40px;
  margin-bottom: 40px;
`;

const App: FC = () => {
  const [msalInstance, setMsalInstance] = useState<IPublicClientApplication | null>(null);

  useEffect(() => {
    const initializeMsal = async () => {
      const instance = await createMsalInstance();
      setMsalInstance(instance);
    };

    initializeMsal();
  }, []);

  if (!msalInstance) {
    return (
      <StyledWrapper>
        <StyledBox>
          <Column>
            <StyledImage src="/icons/VfLogo.svg" alt="Vattenfall Logo" />

            <CircularProgress />
          </Column>
        </StyledBox>
      </StyledWrapper>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Theme>
        <ReduxWrapper>
          <RouterProvider router={router} />
        </ReduxWrapper>
      </Theme>
    </MsalProvider>
  );
};

export default App;
